import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, Stack, Box, Typography, Container, Paper, Button, Divider } from '@mui/material';
import { useGameUtils } from './utilities/GameUtils';
import { CalendarMonth } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import { useAuth } from './contexts/AuthContext';
import { useError } from './contexts/ErrorContext';
import { useProtectedAction } from './hooks/useProtectedAction';
import { useFirebase } from './contexts/FirebaseContext';
import { doc, updateDoc } from 'firebase/firestore';
import GamePoll from './components/GamePoll';
import GameDatePoll from './components/GameDatePoll';
import GameSingleDateActions from './components/GameSingleDateActions';
import GameMatchCarousel from './components/GameMatchCarousel';
import GameButton from './components/GameButton';
import shareIcon from './assets/images/icon-share--grey.svg';
import editIcon from './assets/images/icon-edit--grey.svg';
import gameHeroBg from './assets/images/bg-game-card-purple.png';
import palette from './assets/sass/palette.scss';
import dayjs from 'dayjs';
// import GreenFeesComponent from './components/GreenFeesComponent';
import InvitePlayersComponent from './components/InvitePlayersComponent';
// import GreenFeesViewOnlyComponent from './components/GreenFeesViewOnlyComponent';
import { Select, MenuItem } from '@mui/material';
import MatchContainer from './components/MatchContainer';
import LoadingScreen from './components/LoadingScreen';
import _ from 'lodash';
const GameView = () => {
  const { db } = useFirebase();
  // const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { logFirebaseError } = useError();
  const location = useLocation();
  const subPath = `${location.pathname}/invite`;
  const {
    fetchGameById,
    acceptInvitation,
    createCombinedInvitationsPlayers,
    getAllUserDetailsByUserIds,
    getAllPlayersForGame,
  } = useGameUtils();
  const { id } = useParams();
  const [gameData, setGameData] = useState({
    name: '',
    date: new Date(),
    clubId: '',
    clubName: '',
    courseId: '',
    courseName: '',
    format: '',
    maxPlayers: 2,
    createdBy: '',
    addCosts: false,
    cost: 0,
    costDescription: '',
    splitCosts: false,
    visibility: '',
    gameType: '',
    active: true,
    dateTimeOptions: [],
    shareCode: '',
    allScoresFinalised: false,
  });
  // const canAmendPlayers = gameData.status !== 'finalised' || gameData.status !== 'completed';
  const [usersWithPhotoURL, setUsersWithPhotoURL] = useState([]);
  // const [players, setPlayers] = useState([]);
  const [selectAmountOfMatches, setSelectAmountOfMatches] = useState(gameData.matches?.length || 1);
  const [selectedMatch, setSelectedMatch] = useState((gameData.matches?.length || 1) - 1);
  const isOrganiser = currentUser && currentUser.uid === gameData.createdBy;
  const isCurrentUserPlayer = gameData?.players?.some(
    (player) => player?.user === currentUser?.uid
  );

  const allMatchesScored = gameData?.matches?.every((match) => match.status === 'completed');
  const allMatchesStatusFinalised = gameData?.matches?.every(
    (match) => match.status === 'finalised'
  );
  const allMatchesHavePlayers = gameData?.matches?.every(
    (match) => match.players && match.players.length >= 2
  );
  console.log('gameData', gameData);
  useEffect(() => {
    const fetchUserDetails = async () => {
      const combinedInvitationsPlayers = await createCombinedInvitationsPlayers(gameData);
      const userIds = combinedInvitationsPlayers.map((user) => user.user || user.uid);
      const fullUserData = await getAllUserDetailsByUserIds(userIds);
      setUsersWithPhotoURL(fullUserData);
      if (gameData.status === 'finalised' || gameData.status === 'completed') {
        // const players = await getAllPlayersForGame(id);
        // setPlayers(players);
      }
    };
    fetchUserDetails();
  }, [
    gameData,
    getAllUserDetailsByUserIds,
    createCombinedInvitationsPlayers,
    getAllPlayersForGame,
    id,
  ]);
  console.log('sefton gameData', gameData.status);
  const loadGame = useCallback(
    async (gameId) => {
      const gameData = await fetchGameById(gameId);
      setGameData((prevData) => ({
        ...gameData,
      }));

      const acceptedDates = {};
      gameData.dateTimeOptions.forEach((dt) => {
        if (!dt.acceptedDates || dt.acceptedDates.length === 0) acceptedDates[dt.id] = false;
        for (let j = 0; j < (dt.acceptedBy || []).length; j++) {
          if (currentUser && dt.acceptedBy[j].uid === currentUser.uid) {
            acceptedDates[dt.id] = true;
            break;
          } else {
            acceptedDates[dt.id] = false;
          }
        }
      });
    },
    [fetchGameById, currentUser]
  );

  const userHasAcceptedADate = (user) => {
    if (!user) return false;
    const userId = user.uid;
    const dateTimeOptions = gameData.dateTimeOptions
      .map((dt) => {
        return dt.acceptedBy;
      })
      .flat()
      .map((acceptedBy) => {
        return acceptedBy.uid;
      });
    return dateTimeOptions.includes(userId);
  };

  const userHasDeclined = (user) => {
    if (!user) return false;
    const userId = user.uid;
    const declinedBy = gameData.declinedBy || [];
    return declinedBy.includes(userId);
  };

  // Determine if this is a single-date game
  const isSingleDateGame = () => {
    // Single-date game if:
    // 1. No dateTimeOptions (confirmed game with single date)
    // 2. Only one dateTimeOption
    // 3. Game has status 'confirmed' with a fixed date
    const dateTimeOptionsCount = gameData.dateTimeOptions?.length || 0;
    return dateTimeOptionsCount <= 1 || (gameData.status === 'confirmed' && gameData.date);
  };

  const hasUserAcceptedADate = (user) => {
    if (!user) return false;
    const userId = user.uid;
    
    // For single-date games, check players array
    if (isSingleDateGame()) {
      return gameData?.players?.some(player => player.user === userId) || false;
    }
    
    // For multi-date games, check dateTimeOptions
    const allAccepted = gameData?.dateTimeOptions?.flatMap((dt) => dt.acceptedBy) || [];
    const allAcceptedUids = allAccepted.map((accepted) => accepted.uid);
    return allAcceptedUids.includes(userId);
  };

  const notRespondedYet = !userHasDeclined(currentUser) && !hasUserAcceptedADate(currentUser);
  const hasDeclined = userHasDeclined(currentUser);
  const hasAccepted = hasUserAcceptedADate(currentUser);

  console.log('status notRespondedYet', notRespondedYet);
  console.log('status hasDeclined', hasDeclined);
  console.log('status hasAccepted', hasAccepted);

  const mapLink = useCallback((gameData) => {
    if (!gameData) return '';
    if (gameData.clubLatitude && gameData.clubLongitude) {
      return `https://www.google.com/maps/search/?q=${gameData.clubLatitude},${gameData.clubLongitude}`;
    } else if (gameData.clubPostCode) {
      return `https://www.google.com/maps/search/?q=${gameData.clubPostCode}`;
    }
    return '';
  }, []);

  // const gameImage = () => {
  //   return 'url(https://picsum.photos/192)';
  // };

  const outputSelectedDate = (date) => {
    if (!date) return 'Voting Open';
    if (date.toDate) {
      return format(date.toDate(), "EEEE d MMM 'at\u00A0' h:mmaaa");
    }
    if (date.seconds) {
      return format(new Date(date.seconds * 1000), "EEEE d MMM 'at\u00A0' h:mmaaa");
    }
    if (date instanceof Date) {
      return format(date, "EEEE d MMM 'at\u00A0' h:mmaaa");
    }
    return 'Voting Open';
  };

  const finaliseGame = async () => {
    try {
      const gameRef = doc(db, 'games', id);
      setGameData((prevData) => ({
        ...prevData,
        status: 'finalised',
      }));
      await updateDoc(gameRef, {
        status: 'finalised',
      });
    } catch (error) {
      console.error('Error finalising game:', error);
      await logFirebaseError(error, 'finalise_game', { gameId: id });
    }
  };

  const scoresAreFinalised = async () => {
    try {
      const gameRef = doc(db, 'games', id);
      setGameData((prevData) => ({
        ...prevData,
        allScoresFinalised: true,
      }));
      await updateDoc(gameRef, {
        allScoresFinalised: true,
      });
    } catch (error) {
      console.error('Error finalising scores:', error);
      await logFirebaseError(error, 'finalise_scores', { gameId: id });
    }
  };

  // const handleSelectedDateChange = (event) => {
  //   setSelectedDate(event.target.value);
  // };

  // const hasUserSelectedDate = (idx) => {
  //   return acceptedDates[idx];
  // };

  // const handleSelectedDateOption = (event) => {
  //   const idx = event.target.value;
  //   setAcceptedDates((prevAcceptedDates) => {
  //     const newAcceptedDates = [...prevAcceptedDates];
  //     newAcceptedDates[idx] = !newAcceptedDates[idx];
  //     return newAcceptedDates;
  //   });
  // };

  const currentPlayer = useMemo(() => {
    return gameData?.players?.find((player) => player.user === currentUser?.uid);
  }, [gameData, currentUser]);

  const [handleDecline] = useProtectedAction(() => handleDeclineAction(), {
    message: 'Please sign in to decline this invitation.',
  });

  console.log('currentPlayer:1', currentPlayer);

  // const handleSetSelectedDate = async () => {
  //   try {
  //     const dateTimeOption = gameData.dateTimeOptions.find((dt) => dt.id === selectedDate);

  //     gameData.players = gameData.players || [];
  //     gameData.date = dateTimeOption.option;
  //     gameData.dateId = selectedDate;
  //     gameData.status = 'confirmed';

  //     dateTimeOption.acceptedBy.forEach((inv) => {
  //       gameData.players.push({
  //         user: inv.uid,
  //         userName: inv.userName || '',
  //         score: 0,
  //         paid: false,
  //       });
  //     });

  //     const gameRef = doc(db, 'games', id);
  //     await updateDoc(gameRef, gameData);
  //     // window.location.reload();
  //     loadGame(id);
  //   } catch (error) {
  //     console.error('Error setting selected date:', error);
  //     await logFirebaseError(error, 'set_selected_date', { gameId: id, selectedDate });
  //   }
  // };

  // const calcPercentage = (dt) => {
  //   const votes = (dt.acceptedBy || []).length;
  //   const total = gameData.invitations ? gameData.invitations.length : 1;
  //   if (votes === 0 || total === 0) return 0;
  //   return Math.floor((votes / total) * 100);
  // };

  // const pollEnabled = () => {
  //   let enabled = true;
  //   if (gameData.date) {
  //     const now = new Date();
  //     const gameDate = gameData.date.toDate ? gameData.date.toDate() : new Date(gameData.date);
  //     if (gameDate < now) {
  //       enabled = false;
  //     } else {
  //       const timeDifference = gameDate - now;
  //       const hoursDifference = timeDifference / (1000 * 60 * 60);
  //       if (hoursDifference <= 48) {
  //         enabled = false;
  //       }
  //     }
  //   }
  //   return enabled;
  // };

  const handleVote = (updatedGameData) => {
    // navigate(`/games/${id}`);
    // setGameData(updatedGameData);
    // window.location.reload();
    loadGame(id);
  };

  // const deleteGameById = async (id) => {
  //   try {
  //     const gameRef = doc(db, 'games', id);
  //     await deleteDoc(gameRef);
  //   } catch (error) {
  //     console.error('Error deleting game:', error);
  //     await logFirebaseError(error, 'delete_game', { gameId: id });
  //   }
  // };

  const getOrganizerName = (gameData) => {
    const _organizer = usersWithPhotoURL.find((player) => {
      return player.user === gameData.createdBy;
    });
    if (_organizer?.firstName && _organizer?.lastName) {
      return _.startCase(_organizer?.firstName) + ' ' + _.startCase(_organizer?.lastName);
    } else {
      return _.startCase(_organizer?.username);
    }
  };

  const handleConfirm = (updatedGameData) => {
    // navigate(`/games/${id}`);
    // setGameData(updatedGameData);
    // window.location.reload();
    loadGame(id);
  };

  const handleFinalise = async (updatedGameData) => {
    // try {
    //   // Update local state first
    //   setGameData(updatedGameData);
    //   // Update database
    //   const gameRef = doc(db, 'games', id);
    //   await updateDoc(gameRef, updatedGameData);
    //   // Update related state
    //   if (updatedGameData.matches) {
    //     const numMatches = updatedGameData.matches.length;
    //     setSelectAmountOfMatches(numMatches);
    //     setSelectedMatch(numMatches - 1);
    //   }
    // } catch (error) {
    //   console.error('Error updating game:', error);
    //   // Optionally revert local state if the update fails
    //   // setGameData(prevGameData);
    // }
  };

  useEffect(() => {
    if (id) {
      loadGame(id);
    }
  }, [id, loadGame]);

  // Update selectAmountOfMatches and selectedMatch when gameData changes
  useEffect(() => {
    if (gameData.matches) {
      const numMatches = gameData.matches.length;
      setSelectAmountOfMatches(numMatches);
      setSelectedMatch(numMatches - 1); // -1 because selectedMatch is 0-based
    }
  }, [gameData.matches]);

  const MatchesDropdown = () => {
    const maxNumberOfMatches = 10;
    const matches = [];
    for (let i = 0; i < maxNumberOfMatches; i++) {
      matches.push(
        <MenuItem value={i} key={i}>
          {i + 1}
        </MenuItem>
      );
    }
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          mb: 2,
          justifyItems: 'center',
        }}
      >
        <Typography variant="h6" sx={{ mr: 2 }}>
          Matches
        </Typography>
        <Select
          sx={{
            height: '50px',
            minWidth: '75px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#000',
              borderWidth: '2px',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#000',
              borderWidth: '2px',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#000',
              borderWidth: '2px',
            },
          }}
          value={selectedMatch}
          onChange={handleMatchChange}
        >
          {matches}
        </Select>
        {/* <Button
          variant="contained"
          onClick={() => finaliseGame()}
          sx={{ ml: 2 }}
          disabled={!allMatchesScored}
        >
          Finalise all scored matches and Send Results
        </Button> */}
      </Box>
    );
  };

  const handleMatchChange = (event) => {
    setSelectedMatch(event.target.value);
    setSelectAmountOfMatches(event.target.value + 1);
  };

  const handleDeclineAction = async () => {
    try {
      // Add the current user to the declinedBy array on the game document
      const gameRef = doc(db, 'games', id);
      await updateDoc(gameRef, {
        declinedBy: [...(gameData.declinedBy || []), currentUser.uid],
      });

      // If the user has already accepted a date, remove them from the acceptedBy array
      let updatedDateTimeOptions = gameData.dateTimeOptions || [];
      if (userHasAcceptedADate(currentUser)) {
        updatedDateTimeOptions = gameData.dateTimeOptions.map((dt) => {
          return {
            ...dt,
            acceptedBy: dt.acceptedBy.filter((user) => user.uid !== currentUser.uid),
          };
        });
      }

      // If the user is a player in the game, remove them from the players array
      let updatedPlayers = gameData.players || [];
      if (isCurrentUserPlayer) {
        updatedPlayers = gameData.players.filter((player) => player.user !== currentUser.uid);
      }

      await updateDoc(gameRef, {
        dateTimeOptions: updatedDateTimeOptions,
        players: updatedPlayers,
      });

      // Refresh the page to reflect the changes
      // window.location.reload();
      loadGame(id);
    } catch (error) {
      console.error('Error declining game:', error);
      await logFirebaseError(error, 'decline_game', { gameId: id, userId: currentUser.uid });
    }
  };

  const handleUndecline = async () => {
    try {
      // Remove the current user from the declinedBy array on the game document
      const gameRef = doc(db, 'games', id);
      const updatedDeclinedBy = gameData.declinedBy.filter((uid) => uid !== currentUser.uid);
      await updateDoc(gameRef, {
        declinedBy: updatedDeclinedBy,
      });

      // window.location.reload();
      loadGame(id);
    } catch (error) {
      console.error('Error un-declining game:', error);
      await logFirebaseError(error, 'undecline_game', { gameId: id, userId: currentUser.uid });
    }
  };

  // Handle loading state with conditional rendering instead of early return
  if (!gameData.id) {
    return <LoadingScreen />;
  }

  return (
    <Paper sx={{ flexGrow: 1, pb: 3 }} variant="rightPane">
      {/* {process.env.NODE_ENV === 'development' && <div>{gameData.status}</div>} */}
      <Stack sx={{ mx: 0 }}>
        <Box
          sx={{
            position: 'relative',
            minHeight: 280,
            mx: 0,
            py: 4,
            backgroundImage: `url(${gameHeroBg})`,
            backgroundColor: palette.primary,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Stack sx={{ height: '100%', justifyContent: 'center' }}>
            <Container maxWidth="md">
              <Stack sx={{ alignItems: 'center' }}>
                <Typography variant="h4" flexGrow={1} sx={{ color: 'white', fontWeight: 700 }}>
                  {gameData.name}
                </Typography>
                <Stack direction="row" sx={{ alignItems: 'center' }}>
                  <CalendarMonth sx={{ color: 'white', mr: 1 }} />
                  <Typography variant="h6" sx={{ color: 'white' }}>
                    {outputSelectedDate(gameData.date)}
                  </Typography>
                </Stack>
                {gameData.status === 'pending' && !isSingleDateGame() && (
                  <GameDatePoll
                    gameData={gameData}
                    onVote={handleVote}
                    onConfirm={handleConfirm}
                    onDecline={handleDecline}
                    usersWithPhotoURL={usersWithPhotoURL}
                  />
                )}
                {(gameData.status === 'pending' && isSingleDateGame()) || (gameData.status === 'confirmed' && gameData.date) ? (
                  <GameSingleDateActions
                    gameData={gameData}
                    onAvailable={handleVote}
                    onDecline={handleDecline}
                    usersWithPhotoURL={usersWithPhotoURL}
                  />
                ) : null}
                {gameData.status !== 'pending' && gameData.matches && (
                  <GameMatchCarousel
                    gameData={gameData}
                    users={usersWithPhotoURL}
                    isOrganiser={isOrganiser}
                  />
                )}
              </Stack>
            </Container>
          </Stack>
        </Box>
        <Container maxWidth="md">
          <Stack 
            direction={{ xs: 'column', md: 'row' }} 
            sx={{ 
              justifyContent: 'space-between', 
              paddingY: 2, 
              paddingX: 0,
              gap: { xs: 2, md: 0 }
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: palette.primary, fontSize: '24px', fontWeight: '600' }}
            >
              Game Detail
            </Typography>
            <Stack 
              direction={{ xs: 'column', sm: 'row' }} 
              spacing={2} 
              sx={{ 
                mt: { xs: 0, md: 1 },
                width: { xs: '100%', md: 'auto' }
              }}
            >
{/* Removed duplicate action buttons - now handled by GameSingleDateActions component */}
              {isOrganiser && (
                <GameButton
                  link={`/edit-games/${id}`}
                  icon={editIcon}
                  text="Edit"
                  disabled={!isOrganiser}
                />
              )}
              <GameButton link={`/games/${id}/invite`} icon={shareIcon} text="Share" />
              {/* Only show scoring/finalization buttons to organizer */}
              {isOrganiser && allMatchesScored && !gameData.allScoresFinalised ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    scoresAreFinalised();
                  }}
                >
                  All Scores Final
                </Button>
              ) : isOrganiser && gameData.status !== 'finalised' &&
                !allMatchesScored &&
                selectAmountOfMatches > 0 &&
                !allMatchesStatusFinalised &&
                allMatchesHavePlayers ? (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    finaliseGame();
                  }}
                >
                  All Matches Are Set
                </Button>
              ) : (
                <></>
              )}
            </Stack>
          </Stack>
        </Container>
        <Divider />
      </Stack>

      <Container maxWidth="md" sx={{ mt: 2 }}>
        {gameData.status !== 'pending' &&
          isOrganiser &&
          gameData.status !== 'completed' &&
          gameData.status !== 'finalised' && <MatchesDropdown />}

        {gameData.status !== 'pending' && isOrganiser && (
          <MatchContainer
            gameData={gameData}
            users={usersWithPhotoURL}
            isOrganiser={isOrganiser}
            amountOfMatches={selectAmountOfMatches}
            userHasAcceptedADate={userHasAcceptedADate}
            onFinalise={handleFinalise}
            onMatchesFinalised={(_gameData) => {
              setGameData(_gameData);
            }}
          />
        )}

        {gameData.status === 'pending' && isOrganiser && (
          <GamePoll gameData={gameData} onVote={handleVote} onConfirm={handleConfirm}></GamePoll>
        )}

        <Grid container spacing={3} alignItems="stretch">
          <Grid item xs={12} sm={7}>
            {gameData.competitive && (
              <Paper elevation={0} variant="gameBox">
                <Stack direction="row" sx={{ alignItems: 'center' }}>
                  <Box
                    sx={{
                      borderRadius: '50%',
                      backgroundColor: palette.primary,
                      color: 'white',
                      fontWeight: '400',
                      width: '24px',
                      height: '24px',
                      fontSize: '14px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography
                      variant="factorA"
                      component="span"
                      className="flipped"
                      sx={{ display: 'inline-block' }}
                    >
                      W
                    </Typography>
                  </Box>
                  <Typography variant="moduleHeader" component="h5" sx={{ mb: 0, ml: 1 }}>
                    Competitive
                  </Typography>
                </Stack>
                <Typography variant="small" component="small">
                  This game will effect your WAGL score.
                </Typography>
              </Paper>
            )}
            <Paper elevation={0} variant="gameBox">
              <Typography variant="moduleHeader" component="h5">
                Game Details
              </Typography>
              <Typography variant="body1">Organizer: {getOrganizerName(gameData)}</Typography>
              {gameData.extraDetails && (
                <>
                  <Typography variant="body1">Game description</Typography>
                  <Typography variant="body2" sx={{ mt: 1, mb: 2 }}>
                    {gameData.extraDetails}
                  </Typography>
                </>
              )}
              <Box sx={{ mt: 1 }}>
                <Typography component="span">Type: </Typography>
                <Typography component="span" fontWeight="bold">
                  {gameData.gameType}
                </Typography>
              </Box>
              <Box sx={{ mt: 1 }}>
                <Typography component="span">Format: </Typography>
                <Typography component="span" fontWeight="bold">
                  {gameData.format}
                </Typography>
              </Box>
              <Box sx={{ mt: 1 }}>
                <Typography component="span">Visibility: </Typography>
                <Typography component="span" fontWeight="bold">
                  {gameData.visibility}
                </Typography>
              </Box>
              <Box sx={{ mt: 1 }}>
                <Typography component="span">Green Fees (per person): </Typography>
                <Typography component="span" fontWeight="bold">
                  &pound;
                  {gameData.cost}
                </Typography>
              </Box>
              <Box sx={{ mt: 1 }}>
                <Typography component="span">Course Booked: </Typography>
                <Typography component="span" fontWeight="bold">
                  {gameData.date && gameData.date.toDate
                    ? dayjs(gameData.date.toDate()).format('dddd D MMMM YYYY h:mm A')
                    : 'Not Yet'}
                </Typography>
              </Box>
              {gameData?.whatsAppGroupInviteLink && (
                <Box sx={{ mt: 1 }}>
                  <Typography component="span">Whats App Group Invite: </Typography>
                  <Typography component="span" fontWeight="bold">
                    <a
                      href={gameData.whatsAppGroupInviteLink}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: palette.primary }}
                    >
                      {'Join Group'}
                    </a>
                  </Typography>
                </Box>
              )}
            </Paper>
            <Paper elevation={0} variant="gameBox">
              <Typography variant="moduleHeader" component="h5">
                Location
              </Typography>
              <Typography variant="h6">{gameData.clubName}</Typography>
              <Typography variant="body2">
                <b>
                  {gameData.courseName} (Par {gameData.coursePar})
                </b>
              </Typography>
              <Typography variant="small" component="small">
                {gameData.clubAddress}
              </Typography>
              <br />
              <Typography variant="small" component="small">
                {gameData.clubPostCode}
              </Typography>
              <br />
              <Typography variant="body2" sx={{ textAlign: 'right' }}>
                <a href={mapLink(gameData)} target="_blank" rel="noopener noreferrer">
                  Show Map
                </a>
              </Typography>
            </Paper>
          </Grid>
          <Grid item xs={12} sm={5}>
            <InvitePlayersComponent
              gameData={gameData}
              usersWithPhotoURL={usersWithPhotoURL}
              userHasAcceptedADate={userHasAcceptedADate}
              subPath={subPath}
              hasDate={gameData.date}
            />
          </Grid>
        </Grid>
        <Box sx={{ mt: 5 }}></Box>
      </Container>
    </Paper>
  );
};

export default GameView;
